const URL = process.env.REACT_APP_API_URL

const makeCommits = async (token, username, repo_name, commits) => {
    try {
        const response = await fetch(`${URL}/github/makeCommits`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                username,
                repo_name,
                commits
            })
        });
        const data = await response.json()
        return {status: true, data}
    } catch (e) {
        return {status: false}
    }
}

const testy = () => {
    console.log(100)
}

export {makeCommits, testy}